import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { useGetAllCategoryListQuery } from "../../../../utils/api/category/category.api";
import { usePagination } from "../../../../utils/hooks";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useSearchParams } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import { QueryUrl, sortByAlphabetical } from "../../../../utils/Utils";
import { AlertInfo } from "../../../common/Alert";

const PRIX_PALIERS_DEFAULT = [
  0, 50_000, 100_000, 250_000, 500_000, 1_000_000, 2_000_000, 3_500_000, 5_000_000,
];

function priceToMinIndex(price: number, paliers: number[]): number {
  const maxIdx = paliers.length - 1;
  const i = paliers.findIndex((p) => p >= price);
  return i === -1 ? maxIdx : i;
}
function priceToMaxIndex(price: number, paliers: number[]): number {
  const maxIdx = paliers.length - 1;
  for (let i = maxIdx; i >= 0; i--) {
    if (paliers[i] <= price) return i;
  }
  return 0;
}
function formatPalierLabel(p: number): string {
  if (p >= 1_000_000) return `${p / 1_000_000}M`;
  if (p >= 1_000) return `${p / 1_000}k`;
  return String(p);
}

let options = [
  {
    label: "Nombre d'avis",
    value: "avreageRate",
  },
  {
    label: "Date de création",
    value: "createdAt",
  },
  {
    label: "Nom",
    value: "name",
  },
  {
    label: "Note moyenne",
    value: "rateCount",
  },
  {
    label: "Prix",
    value: "price",
  },
];
function FilterMobileItem({
  searchParams,
  setSearchParams,
  query,
  setQuery,
  setPage,
  show,
  setShow,
  prixPaliers = PRIX_PALIERS_DEFAULT,
}) {
  const paliers = prixPaliers?.length ? prixPaliers : PRIX_PALIERS_DEFAULT;
  const PRIX_SLIDER_MAX_INDEX = paliers.length - 1;

  const [selectedCat, setSelectedCat] = React.useState<any>(
    searchParams?.get("sous_categorie")
      ? JSON.parse(searchParams?.get("sous_categorie") || "[]")
      : []
  );
  const [parent, setParent] = React.useState<any>(
    searchParams?.get("categorie") || ""
  );
  const pmin = searchParams?.get("prix_min");
  const pmax = searchParams?.get("prix_max");
  const minPrice = pmin ? Number(pmin) : 0;
  const maxPrice = pmax ? Number(pmax) : paliers[PRIX_SLIDER_MAX_INDEX];
  const [value, setValue] = React.useState<{ min: number; max: number }>(() => ({
    min: priceToMinIndex(minPrice, paliers),
    max: priceToMaxIndex(maxPrice, paliers),
  }));
  const isBlockedRef = useRef(true);
  const [hoverPrice, setHoverPrice] = useState<{ label: string; x: number; index: number } | null>(null);
  const sliderWrapRef = useRef<HTMLDivElement>(null);

  const getPositionFromEvent = (e: { clientX: number }) => {
    const wrap = sliderWrapRef.current;
    if (!wrap || !paliers.length) return null;
    const rect = wrap.getBoundingClientRect();
    const percent = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
    const index = Math.round(percent * PRIX_SLIDER_MAX_INDEX);
    const clampedIndex = Math.max(0, Math.min(index, PRIX_SLIDER_MAX_INDEX));
    const price = paliers[clampedIndex];
    const label = `${Number(price).toLocaleString("fr-FR")} F CFA`;
    const localX = e.clientX - rect.left;
    return { label, x: localX, index: clampedIndex };
  };

  const handleSliderMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const pos = getPositionFromEvent(e);
    if (pos) setHoverPrice(pos);
  };

  const handleSliderMouseLeave = () => setHoverPrice(null);

  const handleSliderClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const pos = getPositionFromEvent(e);
    if (!pos || isBlockedRef.current) return;
    const idx = pos.index;
    if (idx <= value.min) setValue((v) => ({ ...v, min: Math.min(idx, v.max) }));
    else if (idx >= value.max) setValue((v) => ({ ...v, max: Math.max(idx, v.min) }));
    else if (idx - value.min <= value.max - idx) setValue((v) => ({ ...v, min: Math.min(idx, v.max) }));
    else setValue((v) => ({ ...v, max: Math.max(idx, v.min) }));
  };

  React.useEffect(() => {
    const t = setTimeout(() => {
      isBlockedRef.current = false;
    }, 500);
    return () => clearTimeout(t);
  }, []);
  React.useEffect(() => {
    if (isBlockedRef.current) return;
    const pmin2 = searchParams?.get("prix_min");
    const pmax2 = searchParams?.get("prix_max");
    const minP = pmin2 ? Number(pmin2) : 0;
    const maxP = pmax2 ? Number(pmax2) : paliers[PRIX_SLIDER_MAX_INDEX];
    setValue({
      min: priceToMinIndex(minP, paliers),
      max: priceToMaxIndex(maxP, paliers),
    });
  }, [searchParams?.get("prix_min"), searchParams?.get("prix_max"), paliers]);
  const {
    data = { results: [] },
    isLoading,
    refetch,
  } = useGetAllCategoryListQuery();

  // useEffect(() => {
  //   if (parent) {

  //   }
  // }, [parent])

  React.useEffect(() => {
    let params = QueryUrl("", query);
    setSearchParams(params);
  }, [query]);

  React.useEffect(() => {
    let queryCopy = { ...query };
    queryCopy = {
      ...queryCopy,
      sous_categorie: selectedCat?.length ? JSON.stringify(selectedCat) : "",
    };
    // console.log("query selectedCat", queryCopy);

    setQuery(queryCopy);
  }, [selectedCat]);

  const handleFilter = () => {
    if (isBlockedRef.current) return;
    const queryCopy = {
      ...query,
      prix_min: String(paliers[value.min]),
      prix_max: String(paliers[value.max]),
    };
    setPage(1);
    setQuery(queryCopy);
  };

  useEffect(() => {
    handleFilter();
  }, [value.min, value.max]);

  const handleSelectedCat = (e: ChangeEvent<HTMLInputElement>, item?: { slug?: string }) => {
    let selectedCopy = [...selectedCat];
    if (item && item?.slug !== parent) {
      setParent(item?.slug ?? "");
      const queryCopy = { ...query, categorie: item?.slug ?? "", sous_categorie: "" };
      setQuery(queryCopy);
      selectedCopy = [];
    }
    if (e?.target?.checked) {
      selectedCopy?.push(e?.target?.value);
    } else {
      selectedCopy = selectedCopy?.filter((el) => el !== e?.target?.value);
    }
    setSelectedCat(selectedCopy);
    setPage(1);
  };

  const handleClick = (item) => {
    setParent(item?.slug);
    let queryCopy = { ...query };
    queryCopy = {
      ...queryCopy,
      categorie: item?.slug,
      sous_categorie: [],
    };
    // console.log("query selectedCat", queryCopy);
    setSelectedCat([]);
    setQuery(queryCopy);
    setPage(1);
  };

  const handleClose = () => {
    setShow(false)
  }

  return (
    <Offcanvas show={show} onHide={handleClose} className="offcanvas-filter-mobile">
      <Offcanvas.Header closeButton className="b-b-1">
        <Offcanvas.Title>Filtrer</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="mb-3">
          {/* <div className="content-btn-title-home-page py-3">
                    <div className="tab-dash-admin-filter-container">
                      <form className="tab-dash-admin-filter-form">
                        <div className="">
                          <label
                            htmlFor="filtreProduit"
                            className="tab-dash-admin-filter-label"
                            style={{ fontWeight: 700, color: "#000" }}
                          >
                            Trier par
                          </label>
                        </div>
                        <div className="">
                          <select
                            className="form-control filter-select-product"
                            value={searchParams?.get("orderBy") || ""}
                            onChange={(e) => handleSelect(e)}
                          >
                            <option value="">Pertinence</option>
                            {options?.map((opt, i) => (
                              <option value={opt?.value} key={i}>
                                {" "}
                                {opt?.label}{" "}
                              </option>
                            ))}
                          </select>
                        </div>
                      </form>
                    </div>
                  </div> */}
          <div className="row mt-3">
            {/* {!!isLoading && <ProductItemsSkeleton />} */}

            {/* {!isLoading &&
                      (data?.results?.length ? (
                        data?.results?.map((produit) => (
                          <div
                            className="col-md-6 col-lg-4 col-xl-3 mb-3 col-product-item d-flex"
                            key={produit._id}
                          >
                            <ProductItem item={produit} key={produit._id} />
                          </div>
                        ))
                      ) : (
                        <AlertInfo message="Aucune produit disponible pour le moment!" />
                      ))} */}
            {/* {!! ProductData && ProductData.map((product, key) => {
                        return(
                          <div
                            className="col-md-4 mb-3 col-product-item d-flex"  
                            key={key}
                          >
                            <ProductItem item={product} key={key} refetch={refetch} />
                          </div>
                        )
                      })
                      } */}
          </div>
          <div className="d-flex justify-content-center">
            {/* {data?.nbPage && data?.nbPage > 1 ? (
                      <Pagination
                        page={page}
                        total={data?.nbPage}
                        onPageChange={(page) => setPage(page)}
                      />
                    ) : null} */}
          </div>
        </div>
        <div className="content-others-value filter-mobile-categories">
          <p className="filter-mobile-categories-title">Catégories</p>
          {/* <div
            className="category-filter-list-check"
          >
            {data?.results?.map((item, i) => (
            <label className="material-checkbox mb-3" key={i}>
              <input defaultChecked={catgoryId==item?.id} type="checkbox"  name="categorie" value={item?.id} onChange={(e)=>handleSelectCategory(e)} />
              <span className="checkmark"></span>
                {item?.nom}
            </label>
            ))}
          </div> */}

          <div className="categories_and_subcategories">
            {!!isLoading && <p>Loading...</p>}

            <Accordion
              className="category-filter-acordion"
              id="accordionCategories"
              alwaysOpen
              defaultActiveKey={["0"]}
            >
              {!isLoading &&
                (sortByAlphabetical(data?.results)?.length ? (
                  sortByAlphabetical(data?.results)?.map((category, i) => (
                    <Accordion.Item
                      eventKey={`${i}`}
                      key={category?.id}
                      className="category-filter-acordion-item mb-1"
                    >
                      <Accordion.Header
                        className="mb-0"
                        onClick={() => handleClick(category)}
                      >
                        <span className="category_parent_name">
                          {category?.nom}
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        {category?.sous_categorie?.length ? (
                          sortByAlphabetical(category?.sous_categorie)?.map(
                            (sub) => (
                              <div
                                className="content-col-form-register-tabs cpntrol mb-1"
                                key={sub?.id}
                              >
                                <label className="label-checkbox-register-tabs category_child_name">
                                  <input
                                    type="checkbox"
                                    className="input-checkbox-register-tabs me-2"
                                    checked={
                                      selectedCat &&
                                      selectedCat?.length &&
                                      selectedCat?.includes(sub?.slug)
                                    }
                                    value={sub?.slug}
                                    onChange={(e) => handleSelectedCat(e, category)}
                                  />
                                  {sub?.nom}
                                </label>
                              </div>
                            )
                          )
                        ) : null}
                      </Accordion.Body>
                    </Accordion.Item>
                  ))
                ) : (
                  <AlertInfo message="Aucune catégorie disponible pour le moment" />
                ))}
            </Accordion>
          </div>
        </div>
        <p className="content-title-section-left">
          Prix <span style={{ fontWeight: 300, fontSize: 14 }}>(F CFA)</span>
        </p>
        <div className="filter-prix-slider pb-4 py-4">
          <div
            ref={sliderWrapRef}
            className="filter-prix-slider-wrap"
            onMouseMove={handleSliderMouseMove}
            onMouseLeave={handleSliderMouseLeave}
            onClick={handleSliderClick}
          >
            {hoverPrice && (
              <div
                className="filter-prix-hover-tooltip"
                style={{ left: hoverPrice.x }}
              >
                {hoverPrice.label}
              </div>
            )}
            <InputRange
              minValue={0}
              maxValue={PRIX_SLIDER_MAX_INDEX as number}
              value={value}
              onChange={(v) => setValue(v as { min: number; max: number })}
              formatLabel={(idx) =>
                `${Number(paliers[idx as number]).toLocaleString("fr-FR")} F`
              }
            />
          </div>
          <p className="filter-prix-slider-range mt-2 mb-0 small text-muted text-center">
            {formatPalierLabel(paliers[value.min])} –{" "}
            {formatPalierLabel(paliers[value.max])} F CFA
          </p>
          {/* <div className="filter-prix-paliers mt-1">
            {paliers.slice(1, -1).map((p, i) => (
              <span
                key={`${p}-${i + 1}`}
                className="filter-prix-palier"
                style={{ left: `${((i + 1) / PRIX_SLIDER_MAX_INDEX) * 100}%` }}
              >
                {formatPalierLabel(p)}
              </span>
            ))}
          </div> */}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default FilterMobileItem;
